// extracted by mini-css-extract-plugin
export var button = "_1o-0";
export var buttonContent = "_1o-e";
export var buttonGroup = "_1o-c";
export var dontRestrainIconWidth = "_1o-a";
export var dropdownButton = "_1o-b";
export var iconContainer = "_1o-9";
export var lg = "_1o-4";
export var md = "_1o-3";
export var pending = "_1o-f";
export var sm = "_1o-2";
export var spinner = "_1o-d";
export var squared = "_1o-8";
export var wrapText = "_1o-g";
export var xl = "_1o-5";
export var xs = "_1o-1";
export var xxl = "_1o-6";
export var xxxl = "_1o-7";